<app-number-filter [filter]="filter" [suffix]="' Є'" [dataToView]="dataToView">
</app-number-filter>
